import { ICellRendererParams } from '@ag-grid-community/core'
import { FileOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import { Tooltip } from '@surecompanies/core_components'
import React, { useState } from 'react'
import { HrisCensusReportUploadDto } from '../../../api/dto/hris-census-report-upload.dto'
import { getPresignedHrisReportDownloadUrl } from '../../../api/hris-api-client'
import CensusFilePreviewModal from './CensusFilePreviewModal'

const { Link } = Typography

const HrisReportCellRenderer = (
  params: ICellRendererParams<HrisCensusReportUploadDto>
) => {
  const [previewFile, setPreviewFile] =
    useState<HrisCensusReportUploadDto | null>(null)
  const report = params.data
  const fileName = params.value
  const rowCount = report?.rowCount ?? 0

  if (!report) {
    return null
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          width: '100%',
        }}
      >
        <Tooltip
          color="#f9f9f9"
          overlayInnerStyle={{ color: '#333' }}
          title={`${fileName} (${rowCount})`}
        >
          <Link
            className="textSm"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              minWidth: 0,
            }}
            onClick={() => setPreviewFile(report)}
          >
            <FileOutlined style={{ fontSize: '14px', marginRight: '6px' }} />
            <span
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {fileName} ({rowCount})
            </span>
          </Link>
        </Tooltip>
      </div>

      <CensusFilePreviewModal
        open={previewFile !== null}
        file={previewFile}
        getDownloadUrl={getPresignedHrisReportDownloadUrl}
        onCancel={() => setPreviewFile(null)}
      />
    </>
  )
}

export default HrisReportCellRenderer
